import type React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {COLORS} from "~/style/colors-ts";
import {MONO_FONT} from "~/style/fonts";

export type KpiTone = 'neutral' | 'good' | 'warn' | 'bad';

export type KpiCell = {label: string, value: React.ReactNode, tone?: KpiTone, hint?: string};

const TONE_COLOR: Record<KpiTone, string> = {
    neutral: COLORS.grey[900],
    good: COLORS.success.main,
    warn: COLORS.warning.main,
    bad: COLORS.error.main,
};

/** A row of equal KPI cells (label over a large value). */
export const KpiStrip: React.FC<{cells: KpiCell[]}> = ({cells}) => (
    <Stack direction="row" sx={{border: 1, borderColor: COLORS.grey[150], borderRadius: 1.5, overflow: 'hidden'}}>
        {cells.map(cell => (
            <Box
                key={cell.label}
                title={cell.hint}
                sx={{flex: 1, minWidth: 0, p: 1.5, borderLeft: 1, borderColor: COLORS.grey[150], '&:first-of-type': {borderLeft: 'none'}}}
            >
                <Typography variant="caption" color="grey.700" noWrap component="div">{cell.label}</Typography>
                <Typography sx={{fontFamily: MONO_FONT, fontSize: 20, fontWeight: 600, color: TONE_COLOR[cell.tone ?? 'neutral']}} noWrap>
                    {cell.value}
                </Typography>
            </Box>
        ))}
    </Stack>
);
